<template>
  <div class="container-box">
    <div class="search-box-2">
      <div class="form-row-1">
        <p class="label">조회 기간</p>
        <div class="write-con d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="propDateRange"
              :locale-data="{
                format: 'yyyy-mm-dd',
                applyLabel: '확인',
                cancelLabel: '취소',
              }"
              opens="right"
              @update="onDateChange"
            ></date-range-picker>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              min-width="104px"
              class="button-type-1"
              @click.prevent="registerDays"
            >
              조회
            </v-btn>
          </div>
        </div>
      </div>

      <div class="form-row-1 mt-4">
        <p class="label">집행 매체</p>
        <div class="write-con">
          <div>
            <v-btn
              depressed
              max-height="32px"
              :color="
                mediaLists.length !== mediaListsCheck.length
                  ? '#fecd06'
                  : '#eee'
              "
              class="button-type-1"
              @click.prevent="onCheckAll"
            >
              {{
                mediaLists.length !== mediaListsCheck.length
                  ? '전체 선택'
                  : '선택 해제'
              }}
            </v-btn>
          </div>
          <ul class="chx-list-type-1 five mt-2">
            <li v-for="(media, index) in mediaLists" :key="index">
              <v-checkbox
                v-model="mediaListsCheck"
                :value="media.id"
                :label="media.name"
                color="#fecd00"
                off-icon="mdi-checkbox-blank"
                class="checkbox-type-1"
                hide-details
              >
              </v-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="boardLists.length > 0" class="mt-16">
      <div class="d-flex justify-space-between">
        <h3 class="title-type-2">
          <strong>{{ campaignName }}</strong>
          집행 결과
        </h3>

        <vue-json-to-csv
          :json-data="customLists"
          :csv-title="`${campaignName} 집행 결과`"
        >
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1"
          >
            <v-icon left> mdi-download </v-icon>
            엑셀 다운로드
          </v-btn>
        </vue-json-to-csv>
      </div>

      <div class="table-wrap" v-if="boardLists.length > 0">
        <table class="data-table-1">
          <caption>
            데이터 테이블
          </caption>
          <colgroup>
            <col width="12%" />
            <col />
            <col width="16%" />
            <col width="9%" />
            <col width="9%" />
            <col width="9%" />
            <col width="7%" />
          </colgroup>
          <thead>
            <tr>
              <th scope="row">날짜</th>
              <th scope="row">매체명</th>
              <th scope="row">집행 기간</th>
              <th scope="row">상품(지면)수</th>
              <th scope="row">노출</th>
              <th scope="row">클릭</th>
              <th scope="row">CTR</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th scope="row" colspan="3">총계</th>
              <td>{{ total.inventory_cnt }}</td>
              <td>{{ total.impr | comma }}</td>
              <td>{{ total.click | comma }}</td>
              <td>{{ total.ctr.toFixed(2) + '%' }}</td>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="(item, index) in boardLists" :key="index">
              <td>
                {{ item.day | moment('YYYY.MM.DD') }}
              </td>
              <td>
                {{ item.medias[0].name }}
              </td>
              <td>
                <span v-if="item.medias[0].start_at && item.medias[0].end_at">
                  {{ item.medias[0].start_at | moment('YYYY.MM.DD') }}
                  ~
                  {{ item.medias[0].end_at | moment('YYYY.MM.DD') }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <router-link :to="routeMove(item.medias[0].id)">
                  {{ item.medias[0].inventory_cnt }}
                </router-link>
              </td>
              <td>
                {{ item.medias[0].impr | comma }}
              </td>
              <td>
                {{ item.medias[0].click | comma }}
              </td>
              <td>
                {{
                  item.medias[0].ctr ? item.medias[0].ctr.toFixed(2) + '%' : '-'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import SystemAlert from '~@/modal/SystemAlert.vue';
import bus from '@/utils/bus.js';
import { listMedia } from '@/api/media';
import { reportUserDaysList } from '@/api/report';
import { toISOFormattedDate } from '@/utils/validation';
import moment from 'moment';
import VueJsonToCsv from 'vue-json-to-csv';

let today = new Date();
today.setHours(0, 0, 0, 0);
today = moment(today).add(-1, 'months').subtract(1, 'days').toDate();
let today2 = moment(today).add(1, 'months');

export default {
  props: {
    start_at: String,
    end_at: String,
    dateRanges: Object,
  },
  components: {
    DateRangePicker,
    SystemAlert,
    VueJsonToCsv,
  },
  data: () => ({
    dateRange: {
      startDate: today,
      endDate: today2,
    },
    dateChange: false,
    mediaLists: [],
    mediaListsCheck: [],
    campaignName: null,
    boardLists: [],
    customLists: [],
    total: {
      inventory_cnt: 0,
      impr: 0,
      click: 0,
      ctr: 0,
    },

    showSystemAlert: false,
    logResult: '',

    timeModal: false,
    mediasLists: [],
  }),
  computed: {
    propDateRange: {
      get() {
        return this.dateRanges || this.dateRange;
      },
      set(value) {
        this.dateRange = value;
      },
    },
  },
  methods: {
    async getListMedia() {
      try {
        const { data } = await listMedia();
        const getListMedia = data.list;

        this.mediaLists = getListMedia;

        const mediaListCheck = getListMedia.reduce((previous, current) => {
          previous.push(current.id);
          return previous;
        }, []);

        this.mediaListsCheck = mediaListCheck;

        bus.$emit('end:spinner');
        this.registerDays();
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    onDateChange() {
      this.dateRange.startDate.setHours(0, 0, 0, 0);
      this.dateRange.endDate.setHours(0, 0, 0, 0);
      return (this.dateChange = true);
    },
    onCheckAll() {
      this.mediaLists.length <= this.mediaListsCheck.length
        ? (this.mediaListsCheck = [])
        : this.mediaLists.forEach(media => {
            this.mediaListsCheck.push(media.id);
          });
    },
    async registerDays() {
      try {
        const paramsId = this.$route.params.id;

        const dateS = this.dateRanges
          ? this.dateChange
            ? this.dateRange.startDate
            : this.dateRanges.startDate
          : this.dateRange.startDate;
        const dateE = this.dateRanges
          ? this.dateChange
            ? this.dateRange.endDate
            : this.dateRanges.endDate
          : this.dateRange.endDate;

        let startDate = toISOFormattedDate(dateS);
        let endDate = toISOFormattedDate(dateE);

        const mediaLists = this.mediaListsCheck.reduce((previous, current) => {
          previous.push({ id: current });
          return previous;
        }, []);

        this.mediasLists = mediaLists;

        if (mediaLists.length <= 0) {
          this.showSystemAlert = true;
          this.logResult = '집행 매체를 최소 1개 선택해주세요.';
          return;
        }

        bus.$emit('start:spinner');

        const resultData = () => {
          const result = {
            start_at: startDate,
            end_at: endDate,
          };
          if (mediaLists.length > 0) result.medias = mediaLists;
          return result;
        };

        const { data } = await reportUserDaysList(paramsId, resultData());

        if (data.list.length > 0) {
          this.campaignName = data.campaign.name;
          this.boardLists = data.list;

          const exel = [];
          const total = {
            inventory_cnt: 0,
            impr: 0,
            click: 0,
            ctr: 0,
          };
          data.list.forEach(da => {
            exel.push({
              날짜: `${moment(da.day).format('YYYY.MM.DD')}`,
              매체명: da.medias[0].name,
              '집행 기간': da.medias[0].start_at
                ? `${moment(da.medias[0].start_at).format(
                    'YYYY.MM.DD',
                  )} ~ ${moment(da.medias[0].end_at).format('YYYY.MM.DD')}`
                : '-',
              '상품(지면)수': da.medias[0].inventory_cnt,
              노출: da.medias[0].impr,
              클릭: da.medias[0].click,
              CTR: da.medias[0] ? da.medias[0].ctr.toFixed(2) + '%' : '-',
            });
            total.inventory_cnt =
              total.inventory_cnt + da.medias[0].inventory_cnt;
            total.impr = total.impr + da.medias[0].impr;
            total.click = total.click + da.medias[0].click;
          });
          total.ctr = (total.click / total.impr) * 100;
          this.customLists = exel;
          this.total = total;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
          this.boardLists = [];
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    routeMove(id) {
      const date = this.dateChange ? this.dateRange : this.dateRanges;
      return {
        name: 'reportMedias',
        params: {
          mediaId: id,
          dateRanges: date,
        },
      };
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getListMedia();
  },
};
</script>
